import { render } from "./HelloWorld.vue?vue&type=template&id=1ec17a19&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=1ec17a19&scoped=true&lang=less"

import exportComponent from "/Users/lulitao/Desktop/Vue3+Typescript/web-recorder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec17a19"]])

export default __exports__